import { render, staticRenderFns } from "./ModalComingSoon.vue?vue&type=template&id=59738aec&scoped=true&"
import script from "./ModalComingSoon.vue?vue&type=script&lang=js&"
export * from "./ModalComingSoon.vue?vue&type=script&lang=js&"
import style1 from "./ModalComingSoon.vue?vue&type=style&index=1&id=59738aec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59738aec",
  null
  
)

export default component.exports